export enum WorkerMessageTypeEnum {
  REFRESH_AUTH_TOKEN = 'refreshAuthToken'
}
